import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import './boot.less';
import registerServiceWorker from './registerServiceWorker';
import PhotoBooth from './PhotoBooth';

Modal.setAppElement('#root');

ReactDOM.render(<PhotoBooth />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js